'use client'

import { useEffect } from 'react'
import { useState } from 'react'

import { cn, isTouchDevice } from '@/utils'

import CardMoment, { CardMomentProps } from '../card-moment'

interface HistoryCardMomentProps extends CardMomentProps {
  feeling: string
}

const HistoryCardMoment = ({ feeling, ...props }: HistoryCardMomentProps) => {
  const [isTouch, setIsTouch] = useState(false)

  useEffect(() => {
    setIsTouch(isTouchDevice())
  }, [])

  return (
    <div className="flex items-center">
      <div className={cn('relative', feeling ? 'h-4' : 'h-2')}>
        {feeling ? (
          <div
            style={{
              left: isTouch ? '-25.5px' : '-23px',
            }}
            className="absolute text-base leading-4"
          >
            {feeling}
          </div>
        ) : (
          <div className="absolute -left-[19px] h-2 w-2 rounded-full bg-primary-300" />
        )}
      </div>
      <CardMoment {...props} />
    </div>
  )
}

export default HistoryCardMoment
